/**
 * De donde cuelga el BFF del backoffice.
 *
 * ## Que cambio, y por que no habia alternativa
 *
 * Hasta RIA 3 el navegador le hablaba DIRECTO al emisor: `POST
 * {origin}/idachu/auth/login` con `{ username, password }`, y guardaba los
 * tokens en `localStorage`. Eso dejo de funcionar con idachu 3.x por dos
 * motivos, y ninguno se arregla del lado del cliente:
 *
 *  - el contrato pide `identifier`, no `username`, y ademas exige `app_id`;
 *  - el `app_id` de una superficie viaja junto con su API KEY, que es un
 *    secreto y por lo tanto no puede vivir en el navegador.
 *
 * O sea que el login de una superficie de plataforma NECESITA un servidor
 * confidencial que ponga la app y el contexto. Ese servidor es el BFF que vive
 * en el backend de noten (`backend/src/api/bo/`), igual que el de idachu.
 *
 * ## Por que se DERIVA del prefijo del CRUD y no se fija a `/api/bo`
 *
 * Es la regla IDA-BFF-054 de idachu, y la razon es concreta: la sesion es una
 * cookie, asi que el BFF y el CRUD tienen que estar en el MISMO origen. Un
 * deploy que sirva el backend bajo otro prefijo y un BFF clavado en `/api/bo`
 * mandan la cookie a un origen y las llamadas a otro; el sintoma no es un
 * error legible sino un bucle de 401.
 */

/** El prefijo same-origin del backend de noten. Lo reescribe el proxy. */
const API_PREFIX = '/api';

/**
 * Absoluto y same-origin. RIA valida que la base sea una URL absoluta, asi que
 * el prefijo se resuelve contra `window.location.origin` — sigue pasando por
 * el proxy (Caddy en QA/prod, el de Vite en local), que es lo que mantiene al
 * navegador sin CORS.
 */
export function getApiBaseUrl(): string {
  return new URL(API_PREFIX, window.location.origin).toString().replace(/\/+$/, '');
}

/** El BFF cuelga del MISMO prefijo, un nivel adentro. */
export function getBffBaseUrl(): string {
  return `${getApiBaseUrl()}/bo`;
}
